import TimelineVertical from './TimelineVertical';

export default TimelineVertical;
